import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { post } from "helpers/api_helper";

// Login Redux States
import { FORGET_PASSWORD } from "./actionTypes";
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions";

const sendForgotPassword = async (user) => 
  await post('/auth/forgot-password', { 
    email: user.email || user.username,
    username: user.username || user.email 
  });

// Dispatch real forgot password action to backend
function* forgetUser({ payload: { user, history } }) {
  try {
    const response = yield call(sendForgotPassword, user);

    if (response && response.success !== false) {
      yield put(
        userForgetPasswordSuccess(
          response.message || "Password reset instructions have been sent to your email address."
        )
      );
    } else {
      yield put(userForgetPasswordError(response?.message || response?.error || "Account not found"));
    }
  } catch (error) {
    const errorMsg = 
      error?.response?.data?.message || 
      error?.response?.data?.error || 
      error?.message || 
      "Failed to send reset link. Please try again.";
    yield put(userForgetPasswordError(errorMsg));
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser);
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)]);
}

export default forgetPasswordSaga;
